import React from 'react';
import HoloCard from '../components/HoloCard';
import ReactECharts from 'echarts-for-react';

const BottleneckRadar = () => {
  const radarOptions = {
    backgroundColor: 'transparent',
    tooltip: {},
    radar: {
      indicator: [
        { name: 'CPU Load', max: 100 },
        { name: 'Memory Usg', max: 100 },
        { name: 'Disk I/O', max: 100 },
        { name: 'Network', max: 100 },
        { name: 'DB Locks', max: 100 },
        { name: 'Queue Depth', max: 100 }
      ],
      shape: 'polygon',
      splitNumber: 4,
      axisName: { color: '#64748b' },
      splitLine: { lineStyle: { color: ['rgba(6, 182, 212, 0.1)', 'rgba(6, 182, 212, 0.2)', 'rgba(6, 182, 212, 0.3)', 'rgba(6, 182, 212, 0.4)'] } },
      splitArea: { show: false },
      axisLine: { lineStyle: { color: 'rgba(6, 182, 212, 0.3)' } }
    },
    series: [{
      name: 'System Stress',
      type: 'radar',
      data: [
        {
          value: [45, 80, 30, 90, 20, 85],
          name: 'Current State',
          itemStyle: { color: '#06b6d4' },
          areaStyle: { color: 'rgba(6, 182, 212, 0.3)' }
        },
        {
          value: [30, 40, 20, 50, 10, 30],
          name: 'Baseline',
          itemStyle: { color: '#334155' },
          lineStyle: { type: 'dashed' }
        }
      ]
    }]
  };

  return (
    <div className="space-y-6 h-full flex flex-col">
      <div>
        <h1 className="text-2xl font-light text-white tracking-wide">Bottleneck <span className="font-bold text-cyan-400">Radar</span></h1>
        <p className="text-slate-500 text-sm mt-1">Multi-dimensional stress analysis mapping.</p>
      </div>

      <div className="flex-1 grid grid-cols-1 lg:grid-cols-3 gap-6">
        <HoloCard title="Stress Matrix" className="lg:col-span-2 h-[500px]">
          <ReactECharts option={radarOptions} style={{ height: '100%', width: '100%' }} />
        </HoloCard>
        
        <div className="space-y-6">
          <HoloCard title="Critical Nodes">
            <ul className="space-y-3">
              {[
                { name: 'us-east-worker-01', stress: '92%', type: 'Network' },
                { name: 'db-replica-eu', stress: '85%', type: 'Queue Depth' },
                { name: 'cache-redis-03', stress: '78%', type: 'Memory' }
              ].map((node, i) => (
                <li key={i} className="flex items-center justify-between p-2 bg-slate-900/50 rounded border border-slate-800">
                  <div>
                    <div className="text-sm text-slate-300 font-mono">{node.name}</div>
                    <div className="text-xs text-amber-500/80">{node.type} Issue</div>
                  </div>
                  <div className="text-lg font-bold text-amber-400">{node.stress}</div>
                </li>
              ))}
            </ul>
          </HoloCard>
        </div>
      </div>
    </div>
  );
};

export default BottleneckRadar;